import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface BreadcrumbItem {
  title: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav className={cn("flex items-center gap-2", className)}>
      {items.map((item, index) => (
        <div key={item.title} className="flex items-center">
          {index > 0 && (
            <ChevronRight size={16} className="text-muted-foreground mx-2" />
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap"
            >
              {item.title}
            </Link>
          ) : (
            <span className="text-sm font-medium">{item.title}</span>
          )}
        </div>
      ))}
    </nav>
  );
}
